import { useTranslation } from 'react-i18next';
import { TOCNode } from '../../../types';
import { ChapterButtonClickHandler, ChapterNavigationDirection } from './types';
import { Button, CircularProgress, Stack, Typography } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

export default function TextVariant({
  onClick,
  loading,
  direction,
  chapter,
}: Readonly<{
  direction: ChapterNavigationDirection;
  onClick: ChapterButtonClickHandler;
  loading: boolean;
  chapter: TOCNode;
}>) {
  const { t } = useTranslation();

  const isPrevious = direction === 'previous';
  const textAlign: 'left' | 'right' = isPrevious ? 'left' : 'right';
  const labelKey = isPrevious
    ? 'readingView.navigation.chapter.moveTo.previous.label'
    : 'readingView.navigation.chapter.moveTo.next.label';

  const ArrowIcon = isPrevious ? ArrowBackIosIcon : ArrowForwardIosIcon;
  const IconOrSpinner = loading ? (
    <CircularProgress size={20} sx={{ color: 'action.active' }} />
  ) : (
    <ArrowIcon
      sx={{ color: 'action.active' }}
      role='presentation'
      fontSize='small'
    />
  );

  return (
    <Button
      variant='text'
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        textTransform: 'none',
        color: 'action.active',
        padding: 0,
      }}
    >
      <Stack direction='row' alignItems='center' spacing={3}>
        {isPrevious && IconOrSpinner}
        <Stack direction='column' spacing={0.5}>
          <Typography
            variant='caption'
            color='text.secondary'
            align={textAlign}
          >
            {t(labelKey)}
          </Typography>
          <Typography
            color='text.primary'
            variant='h6'
            align={textAlign}
            sx={{
              wordBreak: 'break-word',
              paddingBottom: 1,
              lineHeight: '150%',
            }}
          >
            {chapter.title}
          </Typography>
        </Stack>
        {!isPrevious && IconOrSpinner}
      </Stack>
    </Button>
  );
}
